import type { GetBidderCreativeQuery } from '../../../graphql/query/creatives/GetBidderCreative.generated';
import { createFieldPathMap } from '../../graphql/parseApolloFieldErrors';
import type { CreativeFormState } from './validation/validationSchema';

type BidderCreative = NonNullable<GetBidderCreativeQuery['bidderCreativeById']>;

export const CREATIVE_FIELD_PATH_MAP = createFieldPathMap<BidderCreative, CreativeFormState>()({
  account_uid: 'account_uid',
  name: 'name',
  crid: 'crid',
  markup_payload: 'markup_payload',
  width: 'width',
  height: 'height',
  iab_categories: 'iab_categories',
  advertiser_domain: 'advertiser_domain',
});
